import React, { Component } from 'react';
import Card from '../../../../components/Card';
import CardHeader from '../../../../components/CardHeader';
import styled from 'styled-components';
import SimpleVerticalBarGraph from '../SimpleVerticalBarGraph';
import { I18n } from 'react-redux-i18n';

const TopCustomersCardContainer = styled.div`
  .chartContainer {
    margin-top: 25px;
  }

  svg .recharts-label-list tspan {
    fill: white !important;
  }
`;

export default class TopCustomersCard extends Component {
  constructor(props) {
    super(props);
  }

  formatData() {
    const data = this.props.data;
    const formattedData = data.map((customer) => {
      return {
        name: customer.customer_name,
        label: {
          value: customer.quantity_eq_75
        },
        value: customer.quantity_eq_75
      };
    });
    return formattedData;
  }

  render() {
    const formattedData = this.formatData();
    return (
      <TopCustomersCardContainer>
        <Card id="directVerticalGraph">
          <CardHeader
            title={I18n.t('negoce.pilotage_interne.topCustomers.title')}
            fontSize="20px"
          />
          <SimpleVerticalBarGraph data={formattedData} />
        </Card>
      </TopCustomersCardContainer>
    );
  }
}
